export default {
  ui: true,
  default: '360p',
}
